import { render, staticRenderFns } from "./form-item-wrapper.vue?vue&type=template&id=efd03992&scoped=true"
import script from "./form-item-wrapper.vue?vue&type=script&lang=js"
export * from "./form-item-wrapper.vue?vue&type=script&lang=js"
import style0 from "./form-item-wrapper.vue?vue&type=style&index=0&id=efd03992&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd03992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efd03992')) {
      api.createRecord('efd03992', component.options)
    } else {
      api.reload('efd03992', component.options)
    }
    module.hot.accept("./form-item-wrapper.vue?vue&type=template&id=efd03992&scoped=true", function () {
      api.rerender('efd03992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/form-item-wrapper.vue"
export default component.exports